export default "/images/petit-logo.svg?4a8f986e7151362faa4dbdadf144a924";